import React from "react";
import { Modal, Row, Col } from "react-bootstrap";
import moment from "moment";
import { capitalizeWords } from "../../common/functions";
import "./OpsDashboard.css";

/**
 * Read-only view modal for queue item in Ops Dashboard.
 * No launch, complete, add note, or other action buttons.
 */
const OpsViewQueueModal = ({ data, show, onHide, orgName }) => {
  if (!data) return null;

  const lastPractitioner =
    data?.practitionerHistory?.[data?.practitionerHistory?.length - 1]?.actor
      ?.display;
  const formatKey = (key) => {
    if (key.includes(" ")) return key;
    return key.replace(/([a-z])([A-Z])/g, "$1 $2");
  };
  const excludedIntakeKeys = [
    "questionnaireResponseId",
    "callerNumber",
    "callerRelationship",
    "callerName",
    "callerNumberExt",
    "reason",
    "location",
    "intakeAssignedPractitioner",
    "zoomTopic",
    "zoomPassword",
  ];

  return (
    <Modal
      backdrop="static"
      show={show}
      onHide={onHide}
      size="xl"
      centered
      className="custom-dialog ops-view-queue-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ textTransform: "capitalize" }}>
          {data?.subject?.display || "Queue Item"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={4}>
            <b>Queue Details</b>
            <div className="col-section mt-2">
              <span className="label-grey">ID:</span> {data?.id || "-"}
              <br />
              <span className="label-grey">Category:</span>{" "}
              {data?.intakeQuestions?.intakePriorityReason || "-"}
              <br />
              <span className="label-grey">Priority:</span> {data?.priority ?? "-"}
              <br />
              <span className="label-grey">Status:</span>{" "}
              <span style={{ textTransform: "capitalize" }}>{data?.status || "-"}</span>
              <br />
              <span className="label-grey">Arrival / Created:</span>{" "}
              {data?.createdAt
                ? moment(data.createdAt).format("DD-MMM-YY HH:mm")
                : "-"}
              <br />
              <span className="label-grey">Location:</span>{" "}
              {data?.patientLocation || "-"}
              <br />
              <span className="label-grey">Organization:</span> {orgName || "-"}
            </div>
          </Col>
          <Col md={4}>
            <b>Call / Contact</b>
            <div className="col-section mt-2" style={{ textTransform: "capitalize" }}>
              <span className="label-grey">Caller Name:</span>{" "}
              {data?.intakeQuestions?.callerName || "-"}
              <br />
              <span className="label-grey">Return Phone:</span>{" "}
              {data?.intakeQuestions?.callerNumber || "-"}
              {data?.intakeQuestions?.callerNumberExt
                ? ` ext. ${data.intakeQuestions.callerNumberExt}`
                : ""}
              <br />
              <span className="label-grey">Reason for Call:</span>{" "}
              {data?.intakeQuestions?.intakeReason ||
                data?.intakeQuestions?.reason ||
                "-"}
              <br />
              <span className="label-grey">Assigned Practitioner:</span>{" "}
              {capitalizeWords(lastPractitioner) || "-"}
            </div>
          </Col>
          <Col md={4}>
            <b>Notes</b>
            <div className="col-section mt-2">
              {data?.notes?.length > 0 ? (
                data.notes.map((note, idx) => (
                  <div key={idx} className="mb-2">
                    <span className="label-grey">
                      {moment(note?.updatedAt).format("DD-MMM-YY HH:mm")} –{" "}
                      {capitalizeWords(note?.actor?.display)}
                    </span>
                    <br />
                    {note?.note}
                  </div>
                ))
              ) : (
                <span className="text-muted">No notes</span>
              )}
            </div>
          </Col>
        </Row>
        {data?.intakeQuestions && Object.keys(data.intakeQuestions).length > 0 && (
          <>
            <hr />
            <Row>
              <Col>
                <b>Intake Questions</b>
                <div className="col-section mt-2">
                  {Object.entries(data.intakeQuestions)
                    .filter(([k]) => !excludedIntakeKeys.includes(k))
                    .map(([key, value]) => {
                      if (value == null || value === "") return null;
                      return (
                        <div key={key}>
                          <span className="label-grey">{formatKey(key)}:</span>{" "}
                          {typeof value === "object"
                            ? JSON.stringify(value)
                            : String(value)}
                        </div>
                      );
                    })}
                </div>
              </Col>
            </Row>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default OpsViewQueueModal;
